<template>
  <v-flex
    id="instruction"
    class="question"
  >
    <p><span class="sz_red--text">*</span> {{ $t('sheet.fields_required') }}</p>
    <h2 class="display-3 display-3_dark mb-1 py-0">
      {{ giftGivingReportQuestions.heading.label }}
    </h2>
    <p
      v-for="(text, index) in giftGivingReportQuestions.heading.text"
      :key="index"
      class="f-1"
      v-html="text"
    />
    <v-divider class="my-4" />
  </v-flex>
</template>

<script>
import links from '@/constants/links';
import { mapGetters } from 'vuex';

export default {
    name: 'GiftGivingInstruction',
    data () {
        return {
            links
        };
    },
    computed: {
        ...mapGetters('giftGivingReport', ['giftGivingReportQuestions']),
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        giftGivingReportElearning () {
            return document.querySelector('[ref="giftGivingReportElearning"]');
        }
    },
    mounted () {
        if (!this.giftGivingReportElearning) return;

        this.setLinkAttributes();

        if (!this.isCurrentEdition) {
            this.handleEditionAccess();
        }
    },
    methods: {
        setLinkAttributes () {
            this.giftGivingReportElearning.setAttribute('href', this.links.GIFT_GIVING_REPORT_GUIDE);
            this.giftGivingReportElearning.setAttribute('target', '_blank');
        },
        handleEditionAccess () {
            this.giftGivingReportElearning.setAttribute('disabled', 'disabled');
        }
    }
};
</script>

<style scoped></style>
